import {scope, type} from 'arktype'

export const StyledText = type({
  'text?': 'string | null',
  'text_style?': 'string | null',
})

export const Price = type({
  'amount?': 'number | null',
  'currency?': 'string | null',
  'styled_text?': [StyledText, '|', 'null'],
})

export const ViewMode = type({
  'layout?': 'string',
  'action_type?': 'string',
  'navigation_type?': 'string',
  'card_type?': 'string',
  'type?': 'string',
})

export const Device = type({
  'portrait': [ViewMode, '|', 'number'],
  'landscape?': [ViewMode, '|', 'number'],
})

export const QuantitySettings = type({
  'default_units?': 'number | null',
  'maximum_units?': 'number | null',
  'minimum_units?': 'number | null',
  'unit_increment?': 'number | null',
})

export const Parameter = type({
  'id': 'string',
  'value?': 'string',
})

export const Request = type({
  parameters: Parameter.array(),
})

export const TopNav = type({
  'desktop?': ViewMode,
  'tablet?': Device,
  'mobile?': Device,
})

export const AssetMedia = type({
  'base_url?': 'string | null',
  'public_id?': 'string | null',
  'format?': 'string | null',
  'tag?': 'string | null',
  'tags?': 'string[] | null',
  'image_source?': 'string | null',
  'uploader_details?': 'string | null',
  'image_description?': 'string | null',
  'image_title?': 'string | null',
  'scale_mode?': 'string | null',
})

export const DeliveryFee = type({
  amount: 'number | null',
  currency: 'string | null',
  styled_text: [StyledText, '|', 'null'],
})

export const DeliveryFeeAllocationInfo = type({
  attribution: 'string | null',
})

export const OrderTypeEstimateRange = type({
  maximum: 'number | null',
  minimum: 'number | null',
})

export const AvailableHour = type({
  'day_of_week?': 'number | null',
  'time_ranges?': 'string[] | null',
})

export const OrderPriceBucketList = type({
  amount: 'number | null',
  buffer_minutes: 'number | null',
})

export const Threshold = type({
  'threshold?': 'number | null',
  'maximum_amount_for_percentage?': 'number | null',
})

export const OrderThresholds = type({
  'currency?': 'string | null',
  'order_price_bucket_list?': [OrderPriceBucketList.array(), '|', 'null'],
})

export const CateringInfo = type({
  catering_sibling_id: 'null | undefined',
  order_thresholds: [OrderThresholds, '|', 'null'],
  catering: 'boolean | null',
})

export const OrderTier = type({
  'threshold_type?': 'string | null',
  'threshold?': 'number | null',
  'additional_prep_time_minutes?': 'number | null',
  'next_delivery_time?': 'string | null',
  'next_order_send_time_delivery?': 'string | null',
  'next_pickup_time?': 'string | null',
  'next_order_send_time_pickup?': 'string | null',
})

export const NextOpenClosedInfo = type({
  'next_order_send_time_delivery?': 'string | null',
  'next_order_send_time_pickup?': 'string | null',
  'next_delivery_time?': 'string | null',
  'next_pickup_time?': 'string | null',
  'next_cutoff_order_send_time_delivery?': 'string | null',
  'next_cutoff_order_send_time_pickup?': 'string | null',
  'order_tiers?': [OrderTier.array(), '|', 'null'],
})

export const DeliveryServiceFeeAllocationInfo = type({
  attribution: 'string | null',
})

export const FeeAllocationInfo = type({
  fee_allocation_type: 'string | null',
})

export const DeliveryFee2 = type({
  'fee_type': 'string | null',
  'percent_value': 'number | null',
  'maximum_amount_for_percent?': [DeliveryFee, '|', 'null'],
})

export const ServiceFee = type({
  name: 'string | null',
  description: 'string | null',
  delivery_fee: [DeliveryFee2, '|', 'null'],
  delivery_service_fee_allocation_info: [DeliveryServiceFeeAllocationInfo, '|', 'null'],
  fee_allocation_info: [FeeAllocationInfo, '|', 'null'],
})

export const Fee = type({
  fee_type: 'string | null',
  flat_cents_value: DeliveryFee,
})

export const SmallOrderFee = type({
  'name?': 'string | null',
  'description?': 'string | null',
  'minimum_order_value_cents?': 'number | null',
  'fee?': [Fee, '|', 'null'],
  'fee_allocation_info?': [DeliveryServiceFeeAllocationInfo, '|', 'null'],
})

// export const ServiceTollFee = type({
//   name: 'string | null',
//   description: 'string | null',
//   fee: [Fee, '|', 'null'],
//   fee_allocation_info: [DeliveryServiceFeeAllocationInfo, '|', 'null'],
// })

// export const SubtitleFeeStyledText = type({
//   text: 'string | null',
//   text_style: 'string | null',
// })

// export const MenuDisplaySetting = type({
//   id: 'string | null',
//   subtitle_fee_styled_text: [SubtitleFeeStyledText, '|', 'null'],
//   disclaimer: 'null | undefined',
// })

// export const FeeDisplaySetting = type({
//   search_display_setting: 'null | undefined',
//   menu_display_setting: [MenuDisplaySetting, '|', 'null'],
// })

// export const GroupedOverridesAvailability = type({
//   delivery_blacked_out: 'boolean | null',
//   pickup_blacked_out: 'boolean | null',
//   delivery_soft_blacked_out: 'boolean | null',
//   pickup_soft_blacked_out: 'boolean | null',
//   delivery_estimate_in_minutes: 'null | undefined',
//   order_minimum_increase_in_cents: 'number | null',
//   inundated: 'boolean | null',
// })

// export const RestaurantAvailabilityDeliveryFee = type({
//   'fee_name': 'string | null',
//   'type': 'string | null',
//   'operand': 'string | null',
//   'amount': 'number | null',
//   'non_adjusted_amount': 'null | undefined',
//   'adjustment': 'null | undefined',
//   'threshold?': [Threshold, '|', 'null'],
//   'potential_adjustment': 'null | undefined',
//   'non_adjusted_values': 'null | undefined',
//   'potential_adjustment_values': 'null | undefined',
//   'applicable_hours': 'null | undefined',
//   'applicable_days_of_the_week': 'null | undefined',
//   'attribution': 'string | null',
//   'fee_adjustment_category': 'string | null',
//   'has_campus_subscription_specific_requirements': 'boolean | null',
//   'amount_benefits': 'null | undefined',
//   'non_adjusted_amount_benefits': 'null | undefined',
//   'potential_adjustment_values_benefits': 'null | undefined',
//   'non_adjusted_values_benefits': 'null | undefined',
//   'potential_adjustment_benefits': 'null | undefined',
// })

// export const DeliveryEstimateRange = type({
//   start_time: 'string | null',
//   end_time: 'string | null',
//   single_estimate_time: 'string | null',
//   start_time_seconds: 'string | null',
//   end_time_seconds: 'string | null',
//   single_estimate_seconds: 'string | null',
//   start_time_minutes: 'number | null',
//   end_time_minutes: 'number | null',
//   single_estimate_minutes: 'number | null',
//   eta_notation: 'string | null',
// })

export const EstimateRange = type({
  start_time: 'string | null',
  end_time: 'string | null',
  single_estimate_time: 'string | null',
  start_time_seconds: 'number | null',
  end_time_seconds: 'number | null',
  single_estimate_seconds: 'number | null',
  start_time_minutes: 'number | null',
  end_time_minutes: 'number | null',
  single_estimate_minutes: 'number | null',
  eta_notation: 'string | null',
})

// export const EtaOption = type({
//   'eta_type': 'string | null',
//   'estimate_range': [EstimateRange, '|', 'null'],
//   'delivery_fee?': [RestaurantAvailabilityDeliveryFee, '|', 'null'],
// })

// export const Threshold2 = type({})

// export const MerchantEtaOptions = type({})

// export const RealTimeEta = type({
//   delivery_estimate_range: [DeliveryEstimateRange, '|', 'null'],
//   pickup_estimate_range: 'number | null',
//   pickup_drive_time_in_minutes: 'number | null',
//   pickup_drive_time_distance_in_miles: 'number | null',
//   eta_options: [EtaOption.array(), '|', 'null'],
//   merchant_eta_options: [MerchantEtaOptions, '|', 'null'],
// })

export const AvailableRestaurantFeatures = type({})

export const Disclaimer = type({})

export const Address = type({
  locality: 'string | null',
  region: 'string | null',
  postal_code: 'string | null',
  zip: 'string | null',
  street_address: 'string | null',
  country: 'string | null',
  time_zone_id: 'string | null',
  phone_number_for_delivery: 'string | null',
  latitude: 'number | null',
  longitude: 'number | null',
})

export const MiscellaneousTaxes = type({})

export const TaxRate = type({
  name: 'string | null',
  rate: 'number | null',
  included_in_item_price: 'boolean | null',
})

export const MediaImage = type({
  'base_url?': 'string | null',
  'public_id?': 'string | null',
  'format?': 'string | null',
  'tag?': 'string | null',
  'tags?': 'string[] | null',
  'image_source?': 'string | null',
  'uploader_details?': 'string | null',
  'image_description?': 'string | null',
  'image_title?': 'string | null',
  'scale_mode?': 'string | null',
})

export const FlexibleTaxFields = type({})

export const FlexibleTaxNumericFields = type({})

export const TagList = type({})

export const MenuItemList = type({
  'id?': 'string | null',
  'restaurant_id?': 'number | null',
  'menu_category_name?': 'string | null',
  'menu_category_id?': 'string | null',
  'name?': 'string | null',
  'description?': 'string | null',
  'price?': [DeliveryFee, '|', 'null'],
  'delivery_price?': [DeliveryFee, '|', 'null'],
  'pickup_price?': [DeliveryFee, '|', 'null'],
  'tax?': 'number | null',
  'tax_rate?': [TaxRate, '|', 'null'],
  'miscellaneous_taxes?': [MiscellaneousTaxes.array(), '|', 'null'],
  'minimum_cart_total?': [DeliveryFee, '|', 'null'],
  'combinable_with_coupons?': 'boolean | null',
  'sequence?': 'number | null',
  'minimum_price_variation?': [DeliveryFee, '|', 'null'],
  'delivery_minimum_price_variation?': [DeliveryFee, '|', 'null'],
  'pickup_minimum_price_variation?': [DeliveryFee, '|', 'null'],
  'maximum_price_variation?': [DeliveryFee, '|', 'null'],
  'delivery_maximum_price_variation?': [DeliveryFee, '|', 'null'],
  'pickup_maximum_price_variation?': [DeliveryFee, '|', 'null'],
  'available?': 'boolean | null',
  'tag_list?': [TagList.array(), '|', 'null'],
  'media_image?': [MediaImage, '|', 'null'],
  'allowable_order_types?': 'string[] | null',
  'lead_time_ms?': 'number | null',
  'menu_item_features?': 'string[] | null',
  'in_store_only?': 'boolean | null',
  'gh_pos_only?': 'boolean | null',
  'calorie_content?': 'string | null',
  'routing_tags?': 'string[] | null',
  'flexible_tax_fields?': [FlexibleTaxFields, '|', 'null'],
  'flexible_tax_numeric_fields?': [FlexibleTaxNumericFields, '|', 'null'],
  'item_coupon?': 'boolean | null',
  'popular?': 'boolean | null',
  'deleted?': 'boolean | null',
})

export const MenuCategoryList = type({
  'id': 'number | null',
  'menu_category_id': 'string | null',
  'name': 'string | null',
  'menu_item_list': [MenuItemList.array(), '|', 'null'],
  'sequence': 'number | null',
  'diner_description?': 'string | null',
  'available': 'boolean | null',
})

export const Rating = type({
  rating_count: 'string | null',
  rating_value: 'string | null',
})

export const RestaurantManageHoursList = type({
  day: 'string | null',
  hours: 'string | null',
  start_time: 'string | null',
  end_time: 'string | null',
})

export const ManagedDeliverySettings = type({
  order_minimum: [DeliveryFee, '|', 'null'],
})

export const OrderFulfillmentMethodsItem = type({
  allowable_order_types: 'string[] | null',
  fulfillment_tags: 'string[] | null',
})

export const OrderFulfillmentMethods = type({
  PICKUP: [OrderFulfillmentMethodsItem, '|', 'null'],
  SELF_DELIVERY: [OrderFulfillmentMethodsItem, '|', 'null'],
  ORDER_BASED_ON_DEMAND_DELIVERY: [OrderFulfillmentMethodsItem, '|', 'null'],
  MANAGED_DELIVERY: [OrderFulfillmentMethodsItem, '|', 'null'],
})

export const FacetedRatingList = type({
  facet_name: 'string | null',
  facet_type: 'string | null',
  response_count: 'number | null',
  positive_response_count: 'number | null',
  positive_response_percentage: 'number | null',
})

export const TopReview = type({
  rating_value: 'number | null',
  review_text: 'string | null',
  reviewer_display_name: 'string | null',
  time_created: 'string | null',
})

export const ReviewData = type({
  total_count: 'number | null',
  valid_count: 'number | null',
  top_review: [TopReview, '|', 'null'],
})

export const FacetedRatingData = type({
  review_data: [ReviewData, '|', 'null'],
  faceted_rating_list: [FacetedRatingList.array(), '|', 'null'],
  faceted_rating_too_few: 'boolean | null',
})

export const AdditionalMediaImages = type({
  'LOGO_HOME_PAGE?': [MediaImage, '|', 'null'],
  'MENU_PAGE?': [MediaImage, '|', 'null'],
  'SEARCH_HOME_PAGE?': [MediaImage, '|', 'null'],
  'SEARCH_RESULTS_PAGE?': [MediaImage, '|', 'null'],
  'HEADER_BACKGROUND?': [MediaImage, '|', 'null'],
})

export const Metadata = type({
  enabled: 'boolean | null',
  location_id: 'string | null',
  program_title: 'string | null',
})

export const BadgeData = type({})

export const BadgeList = type({
  name: 'string | null',
  display_name: 'string | null',
  type: 'string | null',
  badge_data: [BadgeData, '|', 'null'],
  metadata: [Metadata, '|', 'null'],
})

export const MerchantStatus = type({
  category: 'string | null',
  category_description: 'string | null',
  description: 'string | null',
  requires_attrition_reason: 'boolean | null',
  status: 'string | null',
})

export const OrderTypeSettings = type({
  'service_fee?': [ServiceFee, '|', 'null'],
  'small_order_fee?': [SmallOrderFee, '|', 'null'],
  'merchant_status': [MerchantStatus, '|', 'null'],
  'delivery_estimate_minutes': 'number | null',
  'pickup_estimate_minutes': 'number | null',
})

export const VersionIds = type({
  catalog: 'string | null',
})

export const SubscriptionInformation = type({
  order_minimum: 'number | null',
})

export const Values = type({})

export const MenuItemTags = type({
  values: [Values, '|', 'null'],
})

export const Aggregations = type({
  menu_item_tags: [MenuItemTags, '|', 'null'],
})
export const OrderValidationInformation = type({
  opted_in: 'boolean | null',
})

export const TaxEngineInformation = type({
  tax_engine_calculation_enabled: 'boolean | null',
  tax_type_code: 'string | null',
})

// export const Representation = type({
//   'tablet': Device,
//   'mobile': Device,
//   'desktop?': ViewMode,
// })

// export const SequenceOrder = type({
//   desktop: 'number',
//   tablet: Device,
//   mobile: Device,
// })

// export const DisplaySettings = type({
//   'display_type?': 'string | null',
// })

// export const PriceChanges = type({})

// export const MiscellaneousTaxes = type({})

// export const FlexibleTaxNumericFields = type({})

// export const FlexibleTaxFields = type({})

export const types = scope({
  ChoiceCategoryList: {
    'id?': 'string | null',
    'name?': 'string | null',
    'min_choice_options?': 'number | null',
    'max_choice_options?': 'number | null',
    'choice_option_list?': 'ChoiceOptionList[]',
    'variation_target?': 'boolean | null',
    'sequence?': 'number | null',
    'quantity_settings?': [QuantitySettings, '|', 'null'],
    // 'display_settings?': [DisplaySettings, '|', 'null'],
  },
  ChoiceOptionList: {
    'id?': 'string | null',
    'description?': 'string | null',
    'label?': 'string | null',
    'price?': [Price, '|', 'null'],
    'delivery_price?': [Price, '|', 'null'],
    'pickup_price?': [Price, '|', 'null'],
    // 'miscellaneous_taxes?': [MiscellaneousTaxes.array(), '|', 'null'],
    'choice_category_list?': 'ChoiceCategoryList[]',
    'price_changes?': [Price, '|', 'null'],
    // 'sequence?': 'number | null',
    // 'defaulted?': 'boolean | null',
    'quantity_settings?': [QuantitySettings, '|', 'null'],
    // 'tags?': 'string[] | null',
    'asset_media?': [AssetMedia, '|', 'null'],
    'available?': 'boolean | null',
    // 'calorie_content?': 'string | null',
    // 'flexible_tax_fields?': [FlexibleTaxFields, '|', 'null'],
    // 'flexible_tax_numeric_fields?': [FlexibleTaxNumericFields, '|', 'null'],
  },
}).export()

export type ChoiceCategoryList = typeof types.ChoiceCategoryList.infer
export type ChoiceOptionList = typeof types.ChoiceOptionList.infer

// export const SingleFeed = type({
//   'id': 'string',
//   'name': 'string',
//   'representation': Representation,
//   'sequence_order': SequenceOrder,
//   'data_type': 'string',
//   'feed_type': 'string',
//   'retryable': 'boolean',
//   'request': Request,
//   'top_nav': TopNav,
//   'max_number_of_items?': 'number',
//   'description?': 'string',
// })

// export const Routes = type({
//   'SINGLE_FEED?': SingleFeed,
// })

// export const Metadata = type({
//   recommendation_name: 'string',
// })

export const EnhancedFeed = type({
  'id': 'string',
  'name': 'string',
  'description?': 'string',
  // 'representation': Representation,
  // 'sequence_order': SequenceOrder,
  // 'data_type': 'string',
  // 'feed_type': 'string',
  // 'retryable': 'boolean',
  // 'request': Request,
  // 'top_nav': TopNav,
  // 'routes': Routes,
  'max_number_of_items?': 'number',
  // 'metadata?': Metadata,
})

export type EnhancedFeed = typeof EnhancedFeed.infer

// export const Popular = type({
//   enabled: 'boolean',
// })

// export const Spicy = type({
//   enabled: 'boolean',
// })

// export const QuickAddConfiguration = type({
//   state: 'string',
//   action: 'string',
// })

// export const ChoiceOptionIdsMap = type({})

// export const ChoiceOptionDataMap = type({})

// export const Pagination = type({
//   last_page: 'boolean',
// })

export const Pickup = type({
  value: 'number',
  currency: 'string',
  has_costing_required_options: 'boolean',
  required_price_with_choice_options: 'boolean',
  styled_text: StyledText,
})

export const Delivery = type({
  value: 'number',
  currency: 'string',
  has_costing_required_options: 'boolean',
  required_price_with_choice_options: 'boolean',
  styled_text: StyledText,
})

export const ItemPrice = type({
  'pickup?': Pickup,
  'delivery?': Delivery,
})

// export const TaxRate = type({
//   'name?': 'string | null',
//   'rate?': 'number | null',
//   'included_in_item_price?': 'boolean | null',
// })

// export const RoutingTags = type({})

// export const FeaturesV3 = type({})

export const Category = type({
  category_id: 'string',
  category_name: 'string',
})

export const MenuItems = type({
  'item_id?': 'string',
  'item_name?': 'string',
  'item_description?': 'string',
  'item_price?': ItemPrice,
  'media_image?': MediaImage,
  'media_images?': MediaImage.array(),
})

export const Entity = type({
  'item_id?': 'string',
  'item_name?': 'string',
  'item_description?': 'string',
  'item_price?': ItemPrice,
  'media_image?': MediaImage,
  'media_images?': MediaImage.array(),
  'category?': Category,
  'menu_items?': MenuItems.array(),
  // 'features': Features,
  // 'features_v2': Features,
  // 'features_v3': FeaturesV3,
  // 'quick_add_available': 'boolean',
  // 'quick_add_state': 'string',
  // 'quick_add_configuration': QuickAddConfiguration,
  // 'choice_option_ids_map': ChoiceOptionIdsMap,
  // 'choice_option_data_map': ChoiceOptionDataMap,
})

export const Content = type({
  'entity?': Entity,
  'type?': 'string',
})

export const Data = type({
  content: Content.array(),
  enhanced_feed: EnhancedFeed.array(),
})

export const MenuItemData = type({
  content: Content.array(),
})

export const MenuItemObject = type({
  request_id: 'string',
  operation_id: 'string',
  data: MenuItemData,
})
export const Object = type({
  request_id: 'string',
  operation_id: 'string',
  data: Data,
})

export const CategoryList = type({
  object: Object,
  status: 'string',
})

export type CategoryList = typeof CategoryList.infer

export const MenuItemListing = type({
  object: MenuItemObject,
  status: 'string',
})

export type MenuItemListing = typeof MenuItemListing.infer

export const CategoryListQuery = type({
  orderType: 'string',
  platform: 'string',
  enhancedFeed: 'boolean',
  weightedItemDataIncluded: 'boolean',
  location: 'string',
  viewport: 'string',
  restaurantId: 'string',
})

export type CategoryListQuery = typeof CategoryListQuery.infer

export const MenuItemListingQuery = type({
  'time': 'number',
  'location': 'string',
  'operationId': 'string',
  'isFutureOrder': 'boolean',
  'restaurantStatus': 'string',
  'brandUuid': 'string',
  'isNonRestaurantMerchant': 'boolean',
  'merchantTypes': 'string',
  'orderType': 'string',
  'pageSize?': 'number',
  'agent': 'boolean',
  'weightedItemDataIncluded': 'boolean',
  'task': 'string',
  'rpcVariant': 'string',
  'platform': 'string',
  'restaurantId': 'string',
  'menuItemId': 'string',
  'dataType?': 'string',
  'searchQuery?': 'string',
  'sortBy?': 'string',
})
export type MenuItemListingQuery = typeof MenuItemListingQuery.infer

export const CategoryDetailProps = type({
  'id?': 'string | null',
  'restaurant_id?': 'number | null',
  'menu_category_name?': 'string | null',
  'menu_category_id?': 'string | null',
  'name?': 'string | null',
  'description?': 'string | null',
  'price?': [Price, '|', 'null'],
  'delivery_price?': [Price, '|', 'null'],
  'pickup_price?': [Price, '|', 'null'],
  // 'tax?': 'number | null',
  // 'tax_rate?': [TaxRate, '|', 'null'],
  // 'miscellaneous_taxes?': [MiscellaneousTaxes.array(), '|', 'null'],
  // 'minimum_cart_total?': [Price, '|', 'null'],
  // 'combinable_with_coupons?': 'boolean | null',
  // 'sequence?': 'number | null',
  // 'minimum_price_variation?': [Price, '|', 'null'],
  'delivery_minimum_price_variation?': [Price, '|', 'null'],
  'pickup_minimum_price_variation?': [Price, '|', 'null'],
  // 'maximum_price_variation?': [Price, '|', 'null'],
  'delivery_maximum_price_variation?': [Price, '|', 'null'],
  'pickup_maximum_price_variation?': [Price, '|', 'null'],
  'available?': 'boolean | null',
  'choice_category_list?': [types.ChoiceCategoryList.array(), '|', 'null'],
  // 'tag_list?': [TagList, '|', 'null'],
  'media_image?': [AssetMedia, '|', 'null'],
  'media_images?': [AssetMedia.array(), '|', 'null'],
  // 'allowable_order_types?': 'string[] | null',
  // 'lead_time_ms?': 'number | null',
  // 'menu_item_features?': 'string[] | null',
  // 'in_store_only?': 'boolean | null',
  // 'gh_pos_only?': 'boolean | null',
  // 'calorie_content?': 'string | null',
  // 'routing_tags?': [RoutingTags.array(), '|', 'null'],
  // 'flexible_tax_fields?': [FlexibleTaxFields, '|', 'null'],
  // 'flexible_tax_numeric_fields?': [FlexibleTaxNumericFields, '|', 'null'],
  // 'item_coupon?': 'boolean | null',
  // 'popular?': 'boolean | null',
  // 'deleted?': 'boolean | null',
  'maximum_order_quantity?': 'number | null',
  'minimum_order_quantity?': 'number | null',
})

export type CategoryDetailProps = typeof CategoryDetailProps.infer
export const MenuItemDetails = CategoryDetailProps
export type MenuItemDetails = typeof MenuItemDetails.infer

export const MenuItemDetailQuery = type({
  'restaurantId?': 'string | null',
  'menuItemId?': 'string | null',
  'time?': 'number | null',
  'hideUnavailableMenuItems?': 'boolean | null',
  'orderType?': 'string | null',
  'locationMode?': 'string | null',
  'version?': 'number | null',
  'includeWeightedItemsData?': 'boolean | null',
  'location?': 'string | null',
})
export type MenuItemDetailQuery = typeof MenuItemDetailQuery.infer

export const RestaurantAvailability = type({
  restaurant_id: 'string | null',
  // 'delivery_fee': [DeliveryFee, '|', 'null'],
  // 'delivery_fee_without_discounts': [DeliveryFee, '|', 'null'],
  // 'delivery_fee_estimate': [DeliveryFee, '|', 'null'],
  // 'delivery_fee_as_percentage': 'number | null',
  // 'delivery_fee_taxable': 'boolean | null',
  // 'delivery_fee_allocation_info': [DeliveryFeeAllocationInfo, '|', 'null'],
  // 'order_minimum': [DeliveryFee, '|', 'null'],
  // 'sales_tax': 'number | null',
  // 'delivery_offered_to_diner_location': 'boolean | null',
  open: 'boolean | null',
  open_delivery: 'boolean | null',
  open_pickup: 'boolean | null',
  // 'available_for_delivery': 'boolean | null',
  // 'available_for_pickup': 'boolean | null',
  delivery_estimate: 'number | null',
  delivery_estimate_range: 'string | null',
  delivery_estimate_range_v2: [OrderTypeEstimateRange, '|', 'null'],
  pickup_estimate: 'number | null',
  pickup_estimate_range: 'string | null',
  pickup_estimate_range_v2: [OrderTypeEstimateRange, '|', 'null'],
  // 'cash_accepted': 'boolean | null',
  // 'credit_card_accepted': 'boolean | null',
  // 'paypal_accepted': 'boolean | null',
  // 'time_zone_id': 'string | null',
  // 'time_zone_offset': 'number | null',
  // 'tracker': 'boolean | null',
  // 'distance_in_miles': 'number | null',
  decimal_distance_in_miles: 'number | null',
  // 'delivery_cutoff': 'number | null',
  // 'pickup_cutoff': 'number | null',
  // 'delivery_type': 'string | null',
  // 'available_hours': [AvailableHour.array(), '|', 'null'],
  // 'available_hours_pickup': [AvailableHour.array(), '|', 'null'],
  // 'future_order_available_hours_delivery': [AvailableHour.array(), '|', 'null'],
  // 'future_order_available_hours_pickup': [AvailableHour.array(), '|', 'null'],
  // 'min_delivery_fee': [AvailableHour, '|', 'null'],
  // 'catering_info': [CateringInfo, '|', 'null'],
  // 'next_open_closed_info': [NextOpenClosedInfo, '|', 'null'],
  // 'allowable_order_types': 'string[] | null',
  // 'service_fee?': [ServiceFee, '|', 'null'],
  // 'small_order_fee?': [SmallOrderFee, '|', 'null'],
  // 'service_toll_fee?': [ServiceTollFee, '|', 'null'],
  // 'fee_display_setting': [FeeDisplaySetting, '|', 'null'],
  // 'grouped_overrides_availability': [GroupedOverridesAvailability, '|', 'null'],
  // 'contact_free_required': 'boolean | null',
  // 'delivery_fees': [RestaurantAvailabilityDeliveryFee.array(), '|', 'null'],
  // 'pickup_fees': [PickupFees.array(), '|', 'null'],
  // 'real_time_eta?': [RealTimeEta, '|', 'null'],
  // 'cutoff_for_delivery': 'boolean | null',
  // 'cutoff_for_pickup': 'boolean | null',
  // 'white_in': 'boolean | null',
  // 'inundated': 'boolean | null',
  // 'blacked_out': 'boolean | null',
})

export const Restaurant = type({
  'id?': 'string | null',
  'restaurant_hash?': 'string | null',
  'merchant_uuid?': 'string | null',
  'package_state_type_id?': 'number | null',
  // 'available_restaurant_features?': [AvailableRestaurantFeatures.array(), '|', 'null'],
  'available_restaurant_features?': 'string[] | null',
  // 'disclaimers?': [Disclaimer.array(), '|', 'null'],
  // 'duplicate?': 'boolean | null',
  'name?': 'string | null',
  'address?': [Address, '|', 'null'],
  // 'cross_street_required?': 'boolean | null',
  // 'premium?': 'boolean | null',
  // 'online_ordering_available?': 'boolean | null',
  // 'pickup_offered?': 'boolean | null',
  // 'phone_ordering_available?': 'boolean | null',
  'phone_number_for_delivery?': 'string | null',
  // 'suppress_diner_phone_contact?': 'boolean | null',
  'latitude?': 'string | null',
  'longitude?': 'string | null',
  'city_id?': 'number | null',
  // 'managed_delivery?': 'boolean | null',
  // 'delivery_mode?': 'string | null',
  // 'minimum_tip_percent?': 'number | null',
  // 'default_tip_percent?': 'number | null',
  // 'minimum_tip?': [DeliveryFee, '|', 'null'],
  'logo?': 'string | null',
  // 'group_ids?': 'string[] | null',
  // 'has_coupons?': 'boolean | null',
  // 'is_new?': 'boolean | null',
  'cuisines?': 'string[] | null',
  'menu_category_list?': [MenuCategoryList.array(), '|', 'null'],
  // 'restaurant_coupons?': 'string[] | null',
  // 'just_in_time_orders?': 'boolean | null',
  // 'restaurant_cdn_image_url?': 'string | null',
  'media_image?': [MediaImage, '|', 'null'],
  'rating?': [Rating, '|', 'null'],
  // 'price_rating?': 'string | null',
  'rating_bayesian_half_point?': [Rating, '|', 'null'],
  'rating_bayesian10_point?': [Rating, '|', 'null'],
  'restaurant_managed_hours_list_v2?': [RestaurantManageHoursList.array(), '|', 'null'],
  // 'restaurant_intersected_managed_hours_list?': [RestaurantManageHoursList.array(), '|', 'null'],
  // 'managed_delivery_settings?': [ManagedDeliverySettings, '|', 'null'],
  // 'order_fulfillment_methods?': [OrderFulfillmentMethods, '|', 'null'],
  // 'alcohol_enabled?': 'boolean | null',
  // 'alcohol_market_status?': 'string | null',
  // 'faceted_rating_data?': [FacetedRatingData, '|', 'null'],
  // 'additional_media_images?': [AdditionalMediaImages, '|', 'null'],
  // 'tag_list?': 'string[] | null',
  // 'badge_list?': [BadgeList.array(), '|', 'null'],
  // 'available_promo_codes?': 'string[] | null',
  // 'available_offers?': 'string[] | null',
  // 'available_progress_campaigns?': 'string[] | null',
  // 'merchant_url_path?': 'string | null',
  // 'order_type_settings?': [OrderTypeSettings, '|', 'null'],
  // 'pickup_tips_disabled?': 'boolean | null',
  // 'special_instructions_disabled?': 'boolean | null',
  // 'utensils_selection_disabled?': 'boolean | null',
  // 'restaurant_tags?': 'string[] | null',
  // 'version_ids?': [VersionIds, '|', 'null'],
  // 'shared_cart?': 'boolean | null',
  // 'subscription_information?': [SubscriptionInformation, '|', 'null'],
  // 'excluded_menu_item_count?': 'number | null',
  // 'aggregations?': [Aggregations, '|', 'null'],
  // 'chain_id?': 'string | null',
  // 'chain_name?': 'string | null',
  // 'brand_id?': 'string | null',
  // 'brand_name?': 'string | null',
  // 'menu_item_features?': 'string[] | null',
  // 'pos_integrated?': 'boolean | null',
  // 'data_bytes?': 'number | null',
  // 'menu_data_bytes?': 'number | null',
  // 'order_validation_information?': [OrderValidationInformation, '|', 'null'],
  // 'template_type?': 'string | null',
  // 'tax_engine_information?': [TaxEngineInformation, '|', 'null'],
  // 'service_fee_taxable?': 'boolean | null',
  // 'service_fee_taxable_when_delivery_only?': 'boolean | null',
  // 'delivery_fee_taxable_when_delivery_only?': 'boolean | null',
  // 'cash_tip_allowed?': 'boolean | null',
  // 'is_too_few?': 'boolean | null',
  // 'too_few?': 'boolean | null',
})

export const RestaurantDetail = type({
  restaurant_availability: RestaurantAvailability,
  restaurant: Restaurant,
})

export type RestaurantDetail = typeof RestaurantDetail.infer

export const RestaurantDetailQueryProps = type({
  restaurantId: 'string | null',
  hideChoiceCategories: 'boolean | null',
  version: 'number | null',
  variationId: 'string | null',
  orderType: 'string | null',
  hideUnavailableMenuItems: 'boolean | null',
  hideMenuItems: 'boolean | null',
  locationMode: 'string | null',
  location: 'string | null',
})

export type RestaurantDetailQueryProps = typeof RestaurantDetailQueryProps.infer
